
import ISO27001 from "@/pages/specializations/ISO27001";
import Microsoft365Engineering from "@/pages/specializations/Microsoft365Engineering";
import Microsoft365Security from "@/pages/specializations/Microsoft365Security";
import NISTCsf from "@/pages/specializations/NISTCsf";

export const specializationRoutes = [
  { path: "/specializations/iso-27001", element: <ISO27001 /> },
  { path: "/specializations/microsoft-365-engineering", element: <Microsoft365Engineering /> },
  { path: "/specializations/microsoft-365-security", element: <Microsoft365Security /> },
  { path: "/specializations/nist-csf", element: <NISTCsf /> },
];
